<template>
	<ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
		@selection-change="handleSelectionChange" @current-change="handleCurrentChange" @search="handleSearch"
		@reset="resetQuery">
		<template slot="filters">
			<el-form-item label="设备名称" prop="word">
				<el-input v-model="query.word" placeholder="请输入带载设备名称" clearable @keyup.enter.native="handleSearch" />
			</el-form-item>
			<el-form-item label="类型" prop="status">
				<el-select v-model="query.status" placeholder="请选择类型" clearable>
					<el-option label="充电" value="1"></el-option>
					<el-option label="供电" value="0"></el-option>
				</el-select>
			</el-form-item>
		</template>
		<template slot="btns">
			<el-button icon="el-icon-plus" size="mini" type="primary" @click="handleAdd">
				新增带载设备
			</el-button>
			<el-button icon="el-icon-download" size="mini" type="primary" @click="handleExport">
				导出
			</el-button>
			<el-upload style="margin: 0 10px" action="" :show-file-list="false" :before-upload="handleImport">
				<el-button size="small" type="primary">导入</el-button>
			</el-upload>
			<el-button :disabled="ids.length == 0" size="mini" type="success" @click="handleBatchUpdate(1)">
				批量上架
			</el-button>
			<el-button :disabled="ids.length == 0" size="mini" type="info" @click="handleBatchUpdate(0)">
				批量下架
			</el-button>
			<el-button icon="el-icon-download" size="mini" type="text" @click="handleDownload">
				下载模板
			</el-button>
		</template>
		<template slot="columns">
			<el-table-column type="selection" width="50" align="center" />
			<el-table-column label="带载设备名称" align="center" prop="publicName" />
			<el-table-column label="封面" align="center" prop="staticImage">
				<template slot-scope="{ row }">
					<img :src="row.staticImage" style="height: 40px" />
				</template>
			</el-table-column>
			<el-table-column label="类型" align="center" prop="chargingType">
				<template slot-scope="{ row }">
					<el-tag :type="row.chargingType == 0 ? 'success' : ''">
						{{ ['供电', '充电'][row.chargingType] }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="状态" align="center" prop="status">
				<template slot-scope="{ row }">
					<el-tag :type="row.status == 1 ? 'success' : 'info'">
						{{ ['已下架', '已上架'][row.status] }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="140">
				<template slot-scope="{ row }">
					<el-link :underline="false" type="primary" @click="handleEdit(row)">
						编辑
					</el-link>
					<el-link style="margin: 0 10px" :underline="false" :type="row.status == 1 ? 'info' : 'success'"
						@click="handleUpdate(row)">
						{{ row.status == 1 ? '下架' : '上架' }}
					</el-link>
					<el-link :underline="false" type="danger" @click="handleDel(row)">
						删除
					</el-link>
				</template>
			</el-table-column>
		</template>
	</ListPage>
</template>

<script>
import { page, updateStatus, del, excelStencil, excel, importExcel } from "@/api/device";
import listMixin from '@/mixins/list';
import utils from "@/jslibs/utils";

export default {
	data() {
		return {
			// 查询参数
			query: {
				word: "",
				status: undefined
			},
			ids: []
		};
	},
	mixins: [listMixin],
	methods: {
		search() {
			this.loading = true;
			const params = {
				...this.query,
			};
			page(params).then(({ code, data, message }) => {
				if (code == 200) {
					this.tableData = data.records;
					this.total = data.total;
				} else {
					this.$message.error(message);
				}
				this.loading = false;
			});
		},
		handleAdd() {
			this.$router.push("/device/form");
		},
		handleEdit(row) {
			this.$router.push({ path: "/device/form", query: { id: row.id } });
		},
		handleSelectionChange(rows) {
			this.ids = rows.map(item => item.id);
		},
		handleUpdate(row) {
			updateStatus({ idList: [row.id], status: row.status == 1 ? 0 : 1 }).then(({ code, message }) => {
				if (code == 200) {
					this.$message.success("操作成功");
					this.search();
				} else {
					this.$message.error(message);
				}
			});
		},
		handleBatchUpdate(status) {
			updateStatus({ idList: this.ids, status }).then(({ code, message }) => {
				if (code == 200) {
					this.$message.success("批量操作成功");
					this.search();
				} else {
					this.$message.error(message);
				}
			});
		},
		handleDel(row) {
			this.$confirm("是否删除该设备?", "提示", {
				type: "warning",
			})
				.then(() => {
					del(row.id).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("删除成功");
							this.search();
						} else {
							this.$message.error(message);
						}
					});
				})
				.catch(() => { });
		},
		handleExport() {
			excel(this.query).then(res => {
				const blob = new Blob([res]);
				const fileName = `设备列表.xls`;
				utils.downloadBlobFile(blob, fileName);
			});
		},
		handleDownload() {
			excelStencil().then(res => {
				const blob = new Blob([res]);
				const fileName = `设备模板.xls`;
				utils.downloadBlobFile(blob, fileName);
			})
		},
		handleImport(file) {
			importExcel({ file }).then(({ code, message }) => {
				if (code == 200) {
					this.$message.success("导入成功");
					this.handleSearch();
				} else {
					this.$message.error(message);
				}
			});
			return false;
		}
	},
};
</script>